<template>
  <div class="hello">
    <div >
      <div v-for="(item, i) in value" :key="i" >
        <m-audio   :src="item.url" text="点击这里播放" :show-duration="true"  ref="player" :key="i"></m-audio>
        <span class="delImg" @click="delImg(i)">+</span>
      </div>
    </div>
    <div class="thevideo"  v-if="isaudio && iswx">
    <div>
    <img src="../../assets/img/luyin.png" @click="start" height="40" width="40"/>
    </div>
      <div><p>点击开始录音，一次只能录60秒</p></div>
    </div>

  <div class="thevideo" v-if="!isaudio && iswx">
    <div><img src="../../assets/img/playly.png" @click="stop" height="40" width="40"/></div>
      <div> <p>正在录音：{{time}}</p></div>
    </div>
    <div class="thevideo"  v-if="!iswx">
      <div>
        <img src="../../assets/img/luyin.png" @click="callphone" height="40" width="40"/>
      </div>
      <div><p>点击开始录音</p></div>
    </div>
    <van-overlay :show="show" z-index="999999999">
      <div class="wrapper">
        <van-loading text-color="#0094ff" >{{'上传中...'}}</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  const _this = wx
  export default {
    data () {
      return {
        localId: '',
        serverId: '',
        downLoadId: '',
        Soff: true,
        time: 0,
        timer: null,
        isaudio:true,
        iswx:false,
        show:false
      }
    },
  props:{
    kid: String,
    infoid: String,
    value:Array,
  },
    created () {
      //用来判断是app应用还是h5应用，如果是h5应用设置iswx=true
      try {
        this.$jtp('checkApp', "iswx",);
      }catch (e) {
        this.iswx=true;
      }

      if(this.iswx)
      {
        this.initwx()
      }
    },
    methods: {
      //app应用方法
      callphone(){
        this.$jtp('openAudioRecorder','',this.cback)
      },
      cback(res){
        this.saveaudio(res)
      },
      saveaudio(audiodata) {
        let that = this;
        //上传后端备齐一个上传表？还是答案提交采取单题模式？
        let data = new FormData();
        data.append('audiodata', audiodata)
        data.append('iswx', false)
        data.append("mediaid",'')
        data.append("kid",that.kid)
        data.append("infoid",that.infoid)
        this.show = true;
        this.$ajax.post('/student/examonline/downmedia', data).then(function (res) {
          if (res.code == 200) {
            that.value.push({url: res.mediaUrl});
            that.$refs.player.src = res.mediaUrl;
            that.show =false;
          }
        });
      },
      // 微信开始录音
      //初始化微信接口
      initwx()
      {
        var apiUrl = window.location.href
        // let apiUrl = 'http://weixin.lostars.cn'
        let data = new FormData();
        data.append("url",apiUrl)
        this.$ajax.post('/student/examonline/authwejs', data)
          .then((res) => {
            console.log(res)
            _this.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.appId, // 必填，公众号的唯一标识
              timestamp: res.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.nonceStr, // 必填，生成签名的随机串
              signature: res.signature, // 必填，签名
              jsApiList: ['startRecord', 'stopRecord', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'downloadVoice'] // 必填，需要使用的JS接口列表
              // 接口 开始录音接口 停止录音接口 播放语音接口 暂停播放接口 停止播放接口 上传语音接口 下载语音接口 识别音频并返回识别结果接口
            })
            // config信息验证后才执行
            _this.ready(() => {

            })
            // 微信sdk错误返回问题
            _this.error((res) => {
              alert('出错了：' + res.errMsg)// 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
            })
          })
          .catch((error) => {
            console.log(error)
          })
      },
      start (e) {
        let that = this
        that.time = 0
        _this.startRecord({
          success: function () {
            // alert('成功调起录音')
            that.isaudio = false;
            that.timer = setInterval(() => {
              that.time++
            }, 1000)
            that.vicoeEnd()
          },
          cancel: function () {
            alert('用户拒绝授权录音')
          }
        })
      },
      // 停止录音
      stop () {
        let that = this
        // clearInterval(that.timer)
        _this.stopRecord({
          success: function (res) {
            // alert('暂停成功')
            console.log(res)
            clearInterval(that.timer)
            that.localId = res.localId
            that.upVoice()
          },
          fail: function (error) {
            // alert('死啦停不了')
            console.log(error)
          }
        })
      },
      // 取消录音
      cancel () {
        _this.stopRecord({
          success: (res) => {

          }
        })
      },
      // 60秒监听
      vicoeEnd () {
        let that = this
        _this.onVoiceRecordEnd({
          // 录音时间超过一分钟没有停止的时候会执行 complete 回调
          complete: function (res) {
            that.localId = res.localId
            clearInterval(that.timer)
            that.upVoice()
          }
        })
      },
      delImg(index) {
        this.value.splice(index, 1);
        this.$refs.player.pause();
        this.$refs.player.currentTime = 0;
        //将图片保存到rides
        this.$emit('saveanswer');
      },
      // // 播放
       play () {
         let that = this
         console.log(that.localId)
         _this.playVoice({
           localId: that.localId // 需要播放的音频的本地ID，由stopRecord接口获得
         })
       },

      // 上传语音
      upVoice () {
        let that = this
        this.$dialog.confirm({
          title: '提示',
          message: '确认是否上传录音？',
          confirmButtonColor: '#409EFF'
        }).then((res) => {
        _this.uploadVoice({
          localId: that.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: function (res) {
            that.isaudio = true;
            that.serverId = res.serverId // 返回音频的服务器端ID
            let data = new FormData();
            data.append('audiodata', '');
            data.append('iswx', true);
            data.append("mediaid",res.serverId)
            data.append("kid",that.kid)
            data.append("infoid",that.infoid)
            that.show = true;
            that.$ajax.post('/student/examonline/downmedia', data)
              .then((res) => {
                console.log(data)
                that.value.push({url:res.mediaUrl});
                that.$refs.player.src =res.mediaUrl
                that.show=false;
              })
              .catch((error) => {
                console.log(error)
                that.show=false;
              })
          }
        })
        }).catch(()=>{
          that.isaudio = true;
          that.show=false;
        })
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .thevideo{
    text-align: center;
    color: #409EFF;
    margin-top: 30px;
  }
  .delImg {
    position: absolute;
    top: -1px;
    right: -7px;
    width: 22px;
    height: 22px;
    background: #151718;
    border-radius: 50%;
    display: block;
    text-align: center;
    line-height: 22px;
    color: #fff;
    font-weight: 700;
    font-style: normal;
    cursor: pointer;
    /* Rotate div */
    transform: rotate(45deg);
    -ms-transform: rotate(45deg); /* Internet Explorer */
    -moz-transform: rotate(45deg); /* Firefox */
    -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
    -o-transform: rotate(45deg); /* Opera */
  }
</style>



// WEBPACK FOOTER //
// src/components/common/wxaudioplay.vue